import { PersistentCache } from "@unleashed/utils/PersistentCache";

const cache = new PersistentCache();

export const useLocalStorage = () => {
  return cache;
};
